import React, { Component } from 'react';
import './DocsToc.css';

class DocsTocMain extends Component {

  render() {
    return (
      <nav className="docs-nav">
        <ul>
          <li id="quickstart" className={this.props.docInFocus === "quickstart" ? "active" : ""}>
            <a className="docs-nav-item" href='#!' onClick={(e) => {this.props.setDocInFocus("quickstart", e)}} >Quick Start</a>
          </li>
          <li id="usermanual" className={this.props.docInFocus === "usermanual" ? "active" : ""}>
            <a className="docs-nav-item" href='#!' onClick={(e) => {this.props.setDocInFocus("usermanual", e)}} >User Manual</a>
          </li>
          <li id="eplreference" className={this.props.docInFocus === "eplreference" ? "active" : ""}>
            <a className="docs-nav-item" href='#!' onClick={(e) => {this.props.setDocInFocus("eplreference", e)}} >EPL Reference</a>
          </li>
        </ul>
      </nav>
    );
  }
}

export default DocsTocMain;